import React from 'react';
import Wheel from './Wheel';
import SelectOneSectionConfirm from './SelectOneSectionConfirm';
import SelectOolaOneV2 from '../../PortalV2/Steps/Goals/SelectOolaOneV2';
import './OolaOneSectionSelect.css';

const OolaOneSectionSelect = (props) => {
    function changeStep() {
        props.updateIndexStep2(1);
        props.handleChangeHeader(0);
    }

    if (props.portalV2) {
        return (
            <div className="pv2-step2-glass">
                <SelectOolaOneV2
                    AllState={props.AllState}
                    changeData={props.changeData}
                    forceUpdate={props.forceUpdate}
                    handleChangeHeader={props.handleChangeHeader}
                    onContinue={changeStep}
                />
            </div>
        );
    }

    return (
        <section className="selectOolaOneConfirm__container">
            <div className="selectOolaOneConfirm__wrapper">
                <div style={{ height: '70%' }}>
                    <Wheel
                        AllState={props.AllState}
                        hideNav={false}
                        allColors
                    />
                </div>
                <div>
                    <SelectOneSectionConfirm
                        changeStep={changeStep}
                        forceUpdate={props.forceUpdate}
                        AllState={props.AllState}
                        changeData={props.changeData}
                        hideNav={false}
                        updateIndexStep2={props.updateIndexStep2}
                        handleChangeHeader={props.handleChangeHeader}
                    />
                </div>
            </div>
        </section>
    );
};

export default OolaOneSectionSelect;
